import React, { FC, ReactNode } from "react";

import { LinearProgress, Modal } from "@mui/material";
import { useTranslation } from "react-i18next";
import images from "Assets/images";

// Css
import "./style.css";
import "Assets/css/style.css";
import "Assets/css/common.css";
import "Assets/css/booking-list.css";
import "Assets/css/booking-form.css";
import "Assets/css/site-management.css";
import "Assets/css/global-admin.css";
import "Assets/css/cutstmize.css";

export interface ModalWrapperProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  maxWidth?: number;
}

export const ModalWrapper: FC<ModalWrapperProps> = ({
  open,
  onClose,
  children,
  maxWidth,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      classes={{ root: "bulk-apply-modal" }}
      BackdropProps={{
        transitionDuration: 0,
      }}
    >
      <div
        className="modal-content preset-modal"
        style={{ maxHeight: "90vh", maxWidth }}
      >
        {children}
      </div>
    </Modal>
  );
};

export interface ModalHeaderProps {
  title: string | ReactNode;
  onClose?: () => void;
}

export const ModalHeader: FC<ModalHeaderProps> = ({ title, onClose }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="modal-header">
        <h4 className="modal-title">{title}</h4>
        {onClose && (
          <div className="modal-header-button-group" onClick={onClose}>
            <p style={{ margin: 0 }}>{t("Translation.close")}</p>
            <img src={images.closeRoundedButton} alt="" />
          </div>
        )}
      </div>
      <hr className="bottom-divider m-0" />
    </>
  );
};

export interface ModalFooterProps {
  children?: ReactNode;
}

export const ModalFooterWrapper: FC<ModalFooterProps> = ({ children }) => {
  return (
    <>
      <div className="modal-header">{children}</div>
    </>
  );
};

export interface ModalBodyProps {
  isLoading?: boolean;
  children?: ReactNode;
}

export const ModalBody: FC<ModalBodyProps> = ({ children, isLoading }) => {
  return (
    <>
      <div className="modal-body">
        {isLoading ? (
          <LinearProgress color="primary" sx={{ my: 2 }} />
        ) : (
          <>{children}</>
        )}
      </div>
      <hr className="bottom-divider m-0" />
    </>
  );
};
